// pages/Home.js
import React from 'react';
import Hero from '../components/Hero';
import Solutions from '../components/Solutions';
import BrandsCarousel from '../components/BrandsCarousel';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Solutions />
      <BrandsCarousel />
      <CTA />
    </>
  );
};

export default Home;
